export function AppLoadingScreen() {
  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black"
      aria-live="polite"
      aria-busy="true"
      role="status"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(212,175,55,0.08),transparent_50%)]" />
      <div className="relative z-10 flex flex-col items-center gap-8">
        <img
          src="/img/logo.png"
          alt=""
          className="w-16 h-16 md:w-20 md:h-20 object-contain opacity-90"
        />
        <div className="flex flex-col items-center gap-3">
          <div
            className="h-2 w-24 rounded-full bg-gray-800 overflow-hidden"
            aria-hidden
          >
            <div
              className="h-full w-full rounded-full bg-gradient-to-r from-[#D4AF37] via-[#FFD700] to-[#D4AF37] animate-loading-bar"
              style={{
                backgroundSize: '200% 100%',
              }}
            />
          </div>
          <span className="text-sm text-gray-500">Loading...</span>
        </div>
      </div>
    </div>
  )
}
